import {
  LoadingEvent,
  SnackbarApiErrorMessage,
  useDataProvider,
  useSnackbar,
} from '@ui-framework/index';
import React, {
  createContext,
  useContext,
  useMemo,
  useEffect,
  useState,
} from 'react';
import { FormattedMessage } from 'react-intl';

const AvailabilitySlotContext = createContext({});

export function AvailabilitySlotTypeProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const [slotTypes, setSlotTypes] = useState([]);

  const snackbar = useSnackbar();
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { get, getApiUrl } = useDataProvider(provider);

  const fetchSlotTypes = async () => {
    const url = `${getApiUrl()}/sxcl/v1/availability/slot-types?limit=20`;
    const response = await get(url);
    if (response?.ok) {
      return response.data;
    }
    snackbar.showMessage({
      type: 'error',
      data: <SnackbarApiErrorMessage errors={response?.errors} />,
    });
    return null;
  };

  const getSlotByCode = ({ code }) => {
    const slotFound = slotTypes.find(s => s.code === code);
    return slotFound;
  };

  const initialize = async () => {
    setLoading(true);
    try {
      const response = await fetchSlotTypes();
      setSlotTypes(response?.data);
    } catch (err) {
      snackbar.showMessage({
        type: 'error',
        data: <SnackbarApiErrorMessage errors={[{ message: err.message }]} />,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    initialize();
  }, []);

  const value = useMemo(() => ({ slotTypes, getSlotByCode }), [slotTypes]);

  if (loading) {
    return (
      <LoadingEvent>
        <FormattedMessage
          id="LOADING_AVAILABILITY_SLOT_TYPES"
          defaultMessage="Loading Availability Slot Types"
        />
        ...
      </LoadingEvent>
    );
  }

  return (
    <AvailabilitySlotContext.Provider value={value}>
      {children}
    </AvailabilitySlotContext.Provider>
  );
}

export const useAvailabilitySlotTypes = () => {
  return useContext(AvailabilitySlotContext);
};
